import React from "react";
import Box from "components/common/Box";
import Text from "components/common/Text";

/**
 * Figma 7546:57666 — empty-state "Active Plan Detailed" card.
 */
const NoProductsCard = ({ label = "No products till date." }) => (
  <Box
    sx={{
      bgcolor: "#fff",
      border: "1px solid #E2E8F0",
      borderRadius: "20px",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.02)",
      p: 4,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <Text sx={{ fontWeight: 700, fontSize: "14px", color: "#4B5563" }}>
      {label}
    </Text>
  </Box>
);

export default NoProductsCard;
